@use "src/theme";

.tree { outline: none; }
.item {
  display: flex; align-items: center; gap: 6px; min-height: 30px; padding: 4px 8px 4px 4px;
  border-radius: 6px; cursor: default; font-size: 13px; user-select: none; outline: none;
  > .name { flex: 1; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
  > svg { color: var(--color-primary); flex-shrink: 0; }
  // Disabled items are muted, not faded.
  &[aria-disabled="true"], &[aria-disabled="true"] > svg { color: var(--color-muted-foreground); }
  &:hover { background: var(--color-card-hover); }
  &[data-selected], &[data-current] { background: var(--color-primary-soft); }
  &[data-current] { font-weight: 600; }
  // Adjacent selected rows read as one block.
  &[data-selected]:has(+ .item[data-selected]) { border-end-start-radius: 0; border-end-end-radius: 0; }
  &[data-selected] + &[data-selected] { border-start-start-radius: 0; border-start-end-radius: 0; }
  &:focus-visible { @include theme.focus-ring-inset; }
  &[data-drop-active] { box-shadow: inset 0 0 0 2px var(--color-primary); }
}
.disclosure { flex-shrink: 0; width: 20px; height: 20px; }
// The shared icon button sizes itself to a control height; a tree row keeps it compact.
.item > .disclosure:global(.calmlens-button-button) {
  width: 20px; height: 20px; min-height: 0; color: var(--color-muted-foreground);
  svg { min-width: 0; min-height: 0; }
}
.emptyFolder path { stroke-dasharray: 3 2.5; }
// The More button shows on hover, focus, selection or while its menu is open; touch screens always show it.
.item > .more:global(.calmlens-button-button) {
  width: 24px; height: 24px; min-height: 0; flex-shrink: 0; margin-inline-start: auto; opacity: 0;
  color: var(--color-muted-foreground);
}
.item:hover > .more, .item:focus-visible > .more, .item[data-selected] > .more,
.item[data-current] > .more, .item[data-menu-open] > .more { opacity: 1; }
@media (hover: none) { .item > .more:global(.calmlens-button-button) { opacity: 1; } }
.empty {
  display: flex; align-items: center; gap: 6px; min-height: 30px; padding: 4px 8px;
  font-size: 13px; font-style: italic; color: var(--color-muted-foreground); user-select: none;
}

.search {
  width: 100%; min-width: 0; margin-bottom: 8px; padding: 5px 8px;
  border: 1px solid var(--color-border); border-radius: 4px;
  background: var(--color-card); color: var(--color-foreground); font: inherit;
}

.scroll {
  max-height: var(--folder-tree-height, 320px);
  overflow: auto;
  &[data-virtual] { height: var(--folder-tree-height, 320px); }
  &[data-fill] { flex: 1; min-height: 0; height: 0; max-height: none; }
}
